// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { getSearchHistory, SearchHistoryItem } from "@insite/client-framework/Services/AutocompleteService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import getAutocompleteModel from "@insite/client-framework/Store/CommonHandlers/GetAutocompleteModel";
import sendAutocompleteOdpEvent from "@insite/client-framework/Store/CommonHandlers/SendAutocompleteOdpEvent";
import sendSearchTracking from "@insite/client-framework/Store/CommonHandlers/SendSearchTracking";
import {
    getSelectedCategoryPath,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import {
    AutocompleteItemModel,
    AutocompleteModel,
    ProductAutocompleteItemModel,
    ProductModel,
} from "@insite/client-framework/Types/ApiModels";
import AutocompleteBrands, {
    AutocompleteBrandsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import AutocompleteCategories, {
    AutocompleteCategoriesStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import AutocompleteContent, {
    AutocompleteContentStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteContent";
import AutocompleteProducts, {
    AutocompleteProductsStyles,
} from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import AutocompleteSuggestions, {
    AutocompleteSuggestionsStyles,
} from "@store/Overrides/Widgets/Header/AutocompleteSuggestions";
// import SearchHistory, { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory"; // Store Custom Code
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import Search from "@insite/mobius/Icons/Search"; // Starter Custom Code
import Popover, {
    ContentBodyProps,
    OverflowWrapperProps,
    PopoverPresentationProps,
    PositionStyle,
} from "@insite/mobius/Popover";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Starter Custom Code
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import debounce from "lodash/debounce";
import throttle from "lodash/throttle";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";
import { startSearch } from "@insite/client-framework/Store/CommonHandlers/StartSearch";

/* Starter Custom Code - Start */
import { ButtonIcon } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import Icon, { IconProps, IconWrapper } from "@insite/mobius/Icon";
import { StyledTypography } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
import getContentSearchUrl from "@store/Framework/Common/Utilities/getContentSearchUrl";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/ProductList/Handlers/UpdateSearchFields";
import { getContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import { getContentSearchParameter } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import ClockLine from "@store/Library/Components/Icons/Clock/ClockLine";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import {
    searchFields,
    searchCommitBehaviors,
    SearchCommitBehavior,
} from "@store/Overrides/Widgets/Header/HeaderSearchInput";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getProductCollectionV2 } from "@insite/client-framework/Services/ProductServiceV2";
import { lazyLoadKeyframes, lazyLoadStyles } from "@store/Themes/common/mixins/lazyload";
import Clickable from "@insite/mobius/Clickable/Clickable";
import { getOverFlowWrapperProps } from "@store/Framework/Common/Utilities/dynamicSearchHelpers";
import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import BunzlAutoCompleteProducts from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProducts";
import BunzlAutoCompleteProductWrapper from "@store/Library/Components/Bunzl/AutoComplete/BunzlAutoCompleteProductWrapper";
import StoreUser from "@store/Library/Components/Icons/StoreUser";
import SearchHistory, { SearchHistoryStyles } from "@store/Overrides/Widgets/Header/SearchHistory";
import { linkStyles } from "@store/Themes/common/mixins/link";

function isAutocompleteResultEmpty(model: AutocompleteModel | null | undefined): boolean {
    if (!model) {
        return true;
    }
    return (
        !model.products?.length &&
        !model.suggestions?.length &&
        !model.categories?.length &&
        !model.brands?.length &&
        !model.popularCategories?.length &&
        !model.popularBrands?.length &&
        !model.content?.length
    );
}
/* Store Custom Code - End */

interface OwnProps {
    /** A unique identifier to assist with id-generation for `aria-controls`. */
    readonly id: string;
    // Starter Custom Code - >
    searchable: {
        [searchFields.categories]: boolean;
        [searchFields.brands]: boolean;
        [searchFields.contents]: boolean;
        /* Store Custom Code - Start */
        [searchFields.useTabbedHeader]: boolean;
        [searchFields.turnOffEnterSearch]: boolean;
        [searchFields.cardStyle]: "elevated" | "outlined";
        [searchFields.useLegacyAutocomplete]: boolean;
        [searchFields.loadProductsWhileTyping]: boolean;
        [searchFields.searchCommitBehavior]: SearchCommitBehavior;
        /* Store Custom Code - End */
    };
    // <-- Starter Custom Code
    inputRef?: React.Ref<HTMLInputElement>;
    autocompletePositionFunction?: (element: React.RefObject<HTMLUListElement | null>) => PositionStyle;
    onBeforeGoToUrl?: () => void;
    extendedStyles?: SearchInputStyles;
    isAnimated?: boolean;
}
const stableEmptyContentSearchParameter = {};
const mapStateToProps = (state: ApplicationState) => {
    /* Store Custom Code - Start */
    const isAuthenticated = getIsAuthenticated(state);
    const signInUrl = getPageLinkByPageType(state, "SignInPage")?.url;
    const isAddToListModalOpen = state.components.addToListModal.isOpen;
    const { searchWidth, loggedInExtraWidth } = state.bunzl.pages.dynamicSearchWidth;
    /* Store Custom Code - End */
    const {
        searchSettings: { autocompleteEnabled, searchHistoryEnabled, searchHistoryLimit, searchPath },
        extensionContentSearchSettings, // Starter Custom Code
    } = getSettingsCollection(state);
    /* Starter Custom Code - Start */
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;
    const contentSearchCurrentTab = enableContentSearchResults ? getContentSearchCurrentTab(state) : "";
    const contentSearchParameter = enableContentSearchResults
        ? getContentSearchParameter(state)
        : stableEmptyContentSearchParameter;
    /* Starter Custom Code - End */
    return {
        autocompleteEnabled,
        searchHistoryEnabled,
        searchHistoryLimit,
        location: getLocation(state),
        searchPath,
        /* Store Custom Code - Start */
        isAuthenticated,
        signInUrl,
        isAddToListModalOpen,
        searchWidth,
        loggedInExtraWidth,
        /* Store Custom Code - End */
        // Starter Custom Code
        contentSearchCurrentTab,
        contentSearchParameter,
        enableContentSearchResults,
    };
};

const mapDispatchToProps = {
    getAutocompleteModel,
    sendSearchTracking,
    sendAutocompleteOdpEvent,
    startSearch,
    // Starter Custom Code
    updateSearchFields,
};

type Props = OwnProps &
    ThemeProps<BaseTheme> &
    HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

interface State {
    query: string;
    focusableAutocompleteItems: AutocompleteItemModel[];
    focusedAutocompleteItem?: AutocompleteItemModel;
    focusedSearchHistoryQuery?: string;
    autoCompleteModel?: AutocompleteModel | null;
    isLoading: boolean;
    clickedProduct: boolean;
    mobileSearchModalIsOpen: boolean; // Starter Custom Code
    searchIsFocused: boolean; // Store Custom Code
    productsCommitted?: boolean; // Store Custom Code - deferred on-commit products loaded into the dropdown
    productsLoading?: boolean; // Store Custom Code - the on-commit product fetch is in flight (show skeletons)
}

const DOWN_KEY = 40;
const UP_KEY = 38;
const ENTER_KEY = 13;

export interface SearchInputStyles {
    input?: TextFieldPresentationProps;
    popover?: PopoverPresentationProps;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    autocompleteCommerceSearchWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteSuggestionsStyles?: AutocompleteSuggestionsStyles;
    autocompleteCategoriesStyles?: AutocompleteCategoriesStyles;
    autocompleteBrandsStyles?: AutocompleteBrandsStyles;
    autocompleteContentStyles?: AutocompleteContentStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
    // Starter Custom Code
    mobileSearchIcon?: IconProps;
    mobileSearchIconWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchModalCloseIcon?: IconProps;
    // Store Custom Code
    leftColumnWrapper?: InjectableCss;
    rightColumnWrapper?: InjectableCss;
}

// Starter Custom Code
const searchInputGenericHeader = {
    color: "text", // Store Custom Code
    css: css`
        font-size: ${({ theme }) => theme.design.typography.size.large};
        font-weight: ${({ theme }) => theme.design.typography.weight.bold};
    `,
};

const linkAccentStateStyle = {
    color: "primary",
    css: css`
        width: 100%;
        background-color: ${getColor("common.accent")};
    `,
};

/* Store Custom Code - Start */
const autocompleteLinkStyle = {
    css: css`
        ${linkStyles("text.main", "primary", false, true)}
        width: 100%;
    `,
};

const autocompleteFocusedLinkStyle = {
    css: css`
        ${linkStyles("primary", "primary", true, true)}
        width: 100%;
    `,
};
/* Store Custom Code - End */
// Starter Custom Code

export const searchInputStyles: SearchInputStyles = {
    // Store Custom Code - >
    leftColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            ${breakpointValues(["100%", "100%", "75%"], "width")}
        `,
    },
    rightColumnWrapper: {
        css: css`
            display: flex;
            ${breakpointValues(["100%", "100%", "20%"], "width")}
            flex-direction: column;
            gap: ${pxToRem(12)};
            flex-wrap: nowrap;
        `,
    },
    // <-- Bunzl Custom Code
    input: {
        sizeVariant: "default",
        iconProps: {
            src: Search,
            size: 24,
            css: css`
                color: ${getColor("primary")};
            `,
        },
        border: "rectangle",
        cssOverrides: {
            formInputWrapper: css`
                z-index: ${({ theme }) => theme.zIndex.loadingOverlay}; /* Store Custom Code */

                ${IconWrapper} {
                    > * {
                        width: ${pxToRem(24)};
                        height: ${pxToRem(24)};
                    }
                }
            `,
            formField: css`
                width: 100%;
                padding-left: ${x => x.theme.design.layout.spacing.small}; /* Store Custom Code */
                padding-right: ${x => x.theme.design.layout.spacing.small}; /* Store Custom Code */
            `,
            inputSelect: css<any>`
                padding-right: 3em;
                padding-left: ${pxToRem(20)}; /* Store Custom Code */
                ${breakpointValues([null, null, "3em"], "padding-right")}
                border-radius: ${pxToRem(24)}; /* Store Custom Code */
                color: ${getColor("text")}; /* Store Custom Code */

                &:active,
                &:focus {
                    border: ${pxToRem(2)} solid ${getColor("primary")};

                    /* Store Custom Code - Start */
                    border-radius: ${({ theme }) => theme.design.radius.large};
                    padding-left: ${pxToRem(20)};
                    color: ${getColor("text")};

                    /* Store Custom Code - End */
                    ${breakpointValues([null, null, "3em"], "padding-right")}

                    /* Store Custom Code - Start */
                    & + button {
                        background-color: ${getColor("primary")};
                        border-radius: 50%;

                        ${IconWrapper} {
                            color: ${getColor("primary.contrast")};
                        }
                    }

                    /* Store Custom Code - End */
                }
            `,
        },
    },
    popover: {
        transitionDuration: "short",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            justify-content: flex-end;
            /* Bunzl Custom Code */
            display: flex;
            background: white;
        `,
    },
    popoverContentBody: {
        as: "div",

        _height: "calc(100vh - 120px)", // Store Custom Code

        css: css`
            box-shadow: ${({ theme }) => theme.shadows.main};
            border-radius: ${({ theme }) => theme.design.radius.medium}; /* Store Custom Code */
            padding-top: ${pxToRem(62)}; /* Store Custom Code */
            padding-bottom: ${pxToRem(20)}; /* Bunzl Custom Code */

            overflow: hidden; /* Bunzl Custom Code */
            > * {
                width: 100%;
            }
        `,
    },
    /* Store Custom Code - Start */
    autocompleteWrapper: {
        css: css`
            display: flex;
            width: 100%;
            background: white;
            padding: ${pxToRem(20)};
            padding-top: 0;
            margin-top: ${pxToRem(20)};
            overflow-y: auto;
            max-height: calc(100vh - 222px);
            justify-content: space-between;
            ${breakpointValues(["column", "column", "row"], "flex-direction")};
        `,
    },
    /* Store Custom Code - End */
    autocompleteColumnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            /* Bunzl Custom Code */
            flex-wrap: nowrap;
            width: 100%;
            margin-bottom: ${pxToRem(8)};
        `,
    },
    // Starter Custom Code
    searchHistoryStyles: {
        headerText: {
            color: "text", // Store Custom Code
            css: css`
                display: flex;
                margin-bottom: ${pxToRem(5)};
                font-size: ${({ theme }) => theme.design.typography.size.large};
            `,
        },
        wrapper: {
            css: css`
                padding: ${pxToRem(20)};
                overflow-x: hidden;
                /* Bunzl Custom Code */
                background: white;
            `,
        },
        itemWrapper: {
            css: css`
                display: flex;
                align-items: center;
                ${contentSpacingStyles(0, 0, pxToRem(5))}

                &:hover, :focus {
                    ${linkAccentStateStyle.css}
                }
            `,
        },
        icon: {
            src: ClockLine,
            color: "primary",
            size: 18,
            css: css`
                margin-right: ${pxToRem(10)};
            `,
        },
        link: {
            color: "text", // Store Custom Code
            css: css`
                width: 90%;

                &:hover {
                    ${linkAccentStateStyle.css}
                }
            `,
            typographyProps: {
                ellipsis: true,
            },
        },
        focusedLink: linkAccentStateStyle,
        clearLink: {
            color: "primary", // Store Custom Code
            css: css`
                &:hover {
                    > ${StyledTypography} {
                        color: ${getColor("secondary")};
                        text-decoration: underline;
                    }
                }
            `,
            typographyProps: {
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.smaller};
                    font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
                `,
            },
        },
    },
    autocompleteCategoriesStyles: {
        headerText: searchInputGenericHeader,
        link: autocompleteLinkStyle,
        focusedLink: autocompleteFocusedLinkStyle,
        categoryItemText: {
            color: "text.main",
            css: css`
                width: 100%;

                &:hover {
                    color: ${getColor("primary")};
                    text-decoration: underline;
                }
            `,
        },
        focusedCategoryItemText: {
            color: "primary",
            css: css`
                width: 100%;
                text-decoration: underline;
            `,
        },
    },
    autocompleteBrandsStyles: {
        headerText: searchInputGenericHeader,
        link: autocompleteLinkStyle,
        focusedLink: autocompleteFocusedLinkStyle,
        focusedBrandItemText: {
            color: "primary",
            css: css`
                width: 100%;
                text-decoration: underline;
            `,
        },
    },
    autocompleteContentStyles: {
        headerText: searchInputGenericHeader,
        link: autocompleteLinkStyle,
        focusedLink: autocompleteFocusedLinkStyle,
    },
    autocompleteSuggestionsStyles: {
        headerText: searchInputGenericHeader,
        link: autocompleteLinkStyle,
        focusedLink: autocompleteFocusedLinkStyle,
    },
    autocompleteProductsStyles: {
        headerText: searchInputGenericHeader,
        container: {
            css: css`
                margin: ${pxToRem(5)} 0;

                &:hover {
                    .autocomplete-products-link {
                        color: ${getColor("primary")};
                        text-decoration: underline;
                    }
                }
            `,
        },
        focusedContainer: {
            css: css`
                margin: ${pxToRem(5)} 0;

                .autocomplete-products-link {
                    color: ${getColor("primary")};
                    text-decoration: underline;
                }
            `,
        },
        titleLink: {
            color: "text.main", // Store Custom Code
            css: css`
                ${linkStyles("text.main", "primary", false, true)}
                width: 100%;
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
                padding: ${pxToRem(16, 0)};
                border-bottom: ${pxToRem(1)} solid ${getColor("common.borderLight")};
            `,
        },
        erpNumberText: {
            color: "text.main",
            css: css`
                margin: 0;
                font-size: ${({ theme }) => theme.design.typography.size.smaller};
            `,
        },
    },
    mobileSearchIconWrapper: {
        css: css`
            display: flex;
            /* Bunzl Custom Code Start */
            gap: ${pxToRem(24)};
            margin-left: auto;
            width: fit-content;
            /* Bunzl Custom Code End */
        `,
    },
    mobileSearchIcon: {
        color: "primary",
        size: 28,
    },
    mobileSearchModal: {
        cssOverrides: {
            modalContent: css`
                width: 100%;
                padding: ${pxToRem(20)} ${pxToRem(30)};

                > * {
                    padding: 0;
                }
            `,
        },
        closeButtonProps: {
            css: css`
                &:hover {
                    background-color: ${getColor("common.background")};
                    border-color: ${getColor("common.background")};

                    > ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            `,
        },
    },
};

const styles = searchInputStyles;

class SearchInput extends React.Component<Props, State> {
    private readonly styles: SearchInputStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeProps<typeof styles>(styles, props.extendedStyles); // Starter Custom Code
        const parsedQuery = parseQueryString<{ query?: string }>(this.props.location.search);

        this.state = {
            query: parsedQuery.query || "",
            focusableAutocompleteItems: [],
            isLoading: false,
            clickedProduct: true,
            mobileSearchModalIsOpen: false, // Starter Custom Code
            searchIsFocused: false, // Store Custom Code
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
            productsCommitted: false, // Store Custom Code
        };
    }

    list = React.createRef<HTMLUListElement>();
    popover = React.createRef<React.ComponentRef<typeof Popover>>();
    addToListModal = React.createRef<HTMLDivElement>() as React.MutableRefObject<HTMLDivElement | null>;
    searchButton = React.createRef<HTMLButtonElement>(); // Store Custom Code
    showAutocomplete = true;

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            // clear the search box on navigate away from search
            if (!this.props.location.pathname.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`)) {
                // TODO ISC-12679 - Redesign so that this can be moved to a field of the class rather than state.

                this.setState({ query: "" });
            } else {
                this.closeAutocomplete();
            }
        }
        if (this.props.isAddToListModalOpen && !prevProps.isAddToListModalOpen) {
            this.addToListModal.current = document.querySelector("[data-test-selector='productAddToListModal']");
        }
        if (this.state.autoCompleteModel && this.state.autoCompleteModel !== prevState.autoCompleteModel) {
            this.updateFocusableItems();
        }
        if (!this.props.isAddToListModalOpen && prevProps.isAddToListModalOpen && this.state.searchIsFocused) {
            this.focusInput();
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize, true);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.updateFocusableItems();
    };
    /* Store Custom Code - Start */
    focusInput = () => {
        if (this.props.inputRef && "current" in this.props.inputRef) {
            this.props.inputRef.current?.focus();
        }
    };
    /* Store Custom Code - End */
    updateFocusableItems = () => {
        if (this.state.isLoading || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products, popularCategories, popularBrands } =
            this.state.autoCompleteModel;
        /* Store Custom Code - Retail Search returns brand/category suggestions in the top-level
           attributeResults tier (popularCategories/popularBrands); Elasticsearch returns them in
           categories/brands. Focus whichever is populated. */
        const focusCategories = categories && categories.length > 0 ? categories : popularCategories;
        const focusBrands = brands && brands.length > 0 ? brands : popularBrands;
        const isProductsOnTop = true;
        const newFocusableOptions = isProductsOnTop
            ? (products || ([] as AutocompleteItemModel[]))
                  .concat(focusCategories || [])
                  .concat(focusBrands || [])
                  .concat(content || [])
            : (focusCategories || [])
                  .concat(focusBrands || [])
                  .concat(content || [])
                  .concat(products || []);
        this.setState({
            focusableAutocompleteItems: newFocusableOptions,
            focusedAutocompleteItem: undefined,
            focusedSearchHistoryQuery: undefined,
        });
    };

    doSearch = debounce(() => {
        if (this.state.query.trim() === "") {
            return;
        }

        /* Store Custom Code - Start */
        // Deferred product-load commit behaviors (Google mode only, and only when products aren't already
        // shown while typing). progressive: the first commit loads products into the dropdown, a second
        // commit navigates. loadOnly: the commit only loads; the results link navigates. See docs/adr/0003.
        const isGoogleMode = !this.props.searchable.useLegacyAutocomplete;
        const { searchCommitBehavior, loadProductsWhileTyping } = this.props.searchable;
        const productsAlreadyShown =
            loadProductsWhileTyping ||
            !!this.state.autoCompleteModel?.products?.length ||
            !!this.state.productsCommitted;

        if (isGoogleMode && searchCommitBehavior !== searchCommitBehaviors.navigateImmediately) {
            if (!productsAlreadyShown) {
                this.commitLoadProducts(this.state.query);
                return;
            }
            if (searchCommitBehavior === searchCommitBehaviors.loadOnly) {
                // Products already loaded; Enter no longer navigates — the results link does.
                return;
            }
        }
        /* Store Custom Code - End */

        this.showAutocomplete = false;
        /* Store Custom Code */
        this.setState({
            searchIsFocused: false,
        });

        /* Starter Custom Code - Start */
        if (
            this.props.enableContentSearchResults &&
            this.state.autoCompleteModel?.products?.length &&
            this.state.autoCompleteModel?.products?.length > 1
        ) {
            this.props.updateSearchFields({
                ...this.props.contentSearchParameter,
                /*
                      Can't send query here because of the "Did you mean" or "Search results for" of products, 
                      we need the corrected query to update the params
                      */
                currentTab: this.props.contentSearchCurrentTab || constants.contentSearch.tabKey.products,
                cpage: undefined,
            });
        }
        /* Starter Custom Code - End */

        this.props.startSearch({
            query: this.state.query,
            autocompleteModel: this.state.autoCompleteModel || undefined,
            searchPath: this.props.searchPath,
            goToUrl: this.goToUrl,
            searchHistoryEnabled: this.props.searchHistoryEnabled,
            searchHistoryLimit: this.props.searchHistoryLimit,
        });
    }, 300);

    /* Store Custom Code - Start */
    // Map a full ProductModel into the ProductAutocompleteItemModel subset the product cards consume
    // (plain-text display* JSX; enrichment/bolding happens later). Shared by the while-typing (testing)
    // fetch and the deferred on-commit fetch.
    toAutocompleteProduct = (product: ProductModel): ProductAutocompleteItemModel => ({
        uri: product.uri,
        properties: product.properties ?? {},
        id: product.id,
        image: product.smallImagePath || product.mediumImagePath || product.largeImagePath || "",
        url: product.canonicalUrl || product.displayUrl || "",
        title: product.productTitle ?? "",
        displayTitle: <>{product.productTitle}</>,
        subtitle: "",
        displaySubtitle: <></>,
        erpNumber: product.productNumber ?? "",
        displayErpNumber: <>{product.productNumber}</>,
        name: product.productTitle ?? "",
        displayName: <>{product.productTitle}</>,
        isNameCustomerOverride: false,
        manufacturerItemNumber: product.manufacturerItem ?? "",
        displayManufacturerItemNumber: <>{product.manufacturerItem}</>,
        brandName: product.brand?.name ?? "",
        brandDetailPagePath: "",
        styleParentId: null,
    });

    // Deferred "on search" fetch: pull the first 6 products (same endpoint the results page uses) and inject
    // them into the dropdown WITHOUT navigating — the hybrid view. Products render in BunzlAutoCompleteProducts,
    // never in the completions widgets (AutocompleteSuggestions/Categories/Brands). See docs/adr/0003.
    commitLoadProducts = (query: string) => {
        if (query.trim() === "") {
            return;
        }
        // Show the dropdown with product skeletons immediately while the fetch is in flight.
        this.showAutocomplete = true;
        this.setState(
            prev => ({
                autoCompleteModel: { ...(prev.autoCompleteModel ?? {}), products: [] } as AutocompleteModel,
                productsCommitted: false,
                productsLoading: true,
                searchIsFocused: true,
            }),
            () => this.openAutocomplete(),
        );
        getProductCollectionV2({ search: query, relevancy: true, pageSize: 6, searchable: true })
            .then(productCollection => {
                const products = (productCollection?.products ?? []).map(this.toAutocompleteProduct);
                this.showAutocomplete = true;
                this.setState(
                    prev => ({
                        autoCompleteModel: {
                            ...(prev.autoCompleteModel ?? {}),
                            products,
                            attributionToken:
                                productCollection?.attributionToken ?? prev.autoCompleteModel?.attributionToken ?? null,
                        } as AutocompleteModel,
                        productsCommitted: true,
                        productsLoading: false,
                        clickedProduct: false,
                    }),
                    () => {
                        this.openAutocomplete();
                        this.updateFocusableItems();
                    },
                );
            })
            .catch(() => this.setState({ productsLoading: false }));
    };

    getQueryFromSuggestionUrl = (url: string) => {
        const queryString = url.includes("?") ? url.substring(url.indexOf("?") + 1) : "";
        return new URLSearchParams(queryString).get("query") || this.state.query;
    };

    // Suggestion click in Google mode searches products; the fill icon refreshes Google completions instead.
    handleSuggestionSearch = (url: string) => {
        const query = this.getQueryFromSuggestionUrl(url);
        const searchPosition = this.state.autoCompleteModel?.suggestions?.findIndex(o => o.url === url) ?? -1;
        if (searchPosition >= 0) {
            this.props.sendAutocompleteOdpEvent({
                searchQuery: this.state.query,
                searchPosition,
                attributionToken: this.state.autoCompleteModel?.attributionToken,
            });
            this.setState({ clickedProduct: true });
        }
        this.setState({ query, searchIsFocused: true }, () => {
            this.focusInput();
            this.commitLoadProducts(query);
        });
    };

    handleSuggestionPopulate = (text: string) => {
        this.showAutocomplete = true;
        this.setState(
            {
                query: text,
                autoCompleteModel: undefined,
                searchIsFocused: true,
                productsCommitted: false,
                productsLoading: false,
            },
            () => {
                this.focusInput();
                this.openAutocomplete();
                this.loadAutocomplete(text);
            },
        );
    };
    /* Store Custom Code - End */

    loadAutocomplete = debounce((query: string) => {
        /* Store Custom Code - Start */
        // Reset the deferred-commit product state whenever a new query is typed.
        if (this.state.productsCommitted || this.state.productsLoading) {
            this.setState({ productsCommitted: false, productsLoading: false });
        }

        const useLegacyAutocomplete = this.props.searchable.useLegacyAutocomplete;

        // Immediate-hybrid TESTING mode only: fire the products API in PARALLEL with autocomplete on every
        // keystroke. Deferred (prod) mode leaves this off and fetches products only on search commit.
        const productsPromise = this.props.searchable.loadProductsWhileTyping
            ? getProductCollectionV2({ search: query, relevancy: true, pageSize: 6, searchable: true }).catch(
                  () => undefined,
              )
            : undefined;
        /* Store Custom Code - End */

        this.props.getAutocompleteModel({
            query,
            // Store Custom Code
            // legacy = relevancy off (Elasticsearch, autocomplete only); otherwise on (Google Retail Search on sandbox)
            relevancy: !useLegacyAutocomplete,
            onSuccess: async result => {
                if (!this.showAutocomplete) {
                    return;
                }
                /* Store Custom Code - Start */
                if (productsPromise) {
                    const productCollection = await productsPromise;
                    if (productCollection) {
                        result.products = (productCollection.products ?? []).map(this.toAutocompleteProduct);
                        if (productCollection.attributionToken && !result.attributionToken) {
                            result.attributionToken = productCollection.attributionToken;
                        }
                    }
                }
                /* Store Custom Code - End */
                if (this.state.query !== query) {
                    return;
                }
                this.setState({
                    autoCompleteModel: result,
                    clickedProduct: false,
                });
                /* Store Custom Code - Start */
                if (this.state.searchIsFocused) {
                    this.openAutocomplete();
                }

                if (!this.state.focusableAutocompleteItems.length) {
                    this.updateFocusableItems();
                }
                /* Store Custom Code - End */
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    this.onSuccess?.(resultProps.apiResult);
                }
            },
        });
    }, 500);

    handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.showAutocomplete = true;
        const newQuery = event.target.value;
        this.setState({ query: newQuery, autoCompleteModel: undefined, searchIsFocused: true }, () =>
            this.openAutocomplete(),
        );
        this.loadAutocomplete(newQuery);
    };

    openAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    closeAutocomplete = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    getPopoverPosition = (element: React.RefObject<HTMLUListElement | null>) => {
        if (this.props.autocompletePositionFunction) {
            return this.props.autocompletePositionFunction(element);
        }

        const positionStyle: PositionStyle = {
            position: "absolute", // Store Custom Code
        };

        if (element.current) {
            // Starter Removed Code - Old Positioning
            // Starter Custom Code
            positionStyle.top = `-${pxToRem(18)}`; // Store Custom Code
            positionStyle.right = 0;
            positionStyle.left = 0;
            // Starter Custom Code
        }

        return positionStyle;
    };

    moveFocus = throttle((direction: "prev" | "next") => {
        if (this.state.query) {
            this.setState(({ focusedAutocompleteItem, focusableAutocompleteItems }) => {
                const focusableQueue =
                    direction === "prev" ? focusableAutocompleteItems.slice().reverse() : focusableAutocompleteItems;
                const focusedIndex = focusableQueue.indexOf(focusedAutocompleteItem as AutocompleteItemModel);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedAutocompleteItem: newFocusedOption };
            });
        } else {
            this.setState(({ focusedSearchHistoryQuery }) => {
                const searchHistoryItems = getSearchHistory();
                const focusableQueue = direction === "prev" ? searchHistoryItems.slice().reverse() : searchHistoryItems;
                const focusedSearchHistoryItem = focusableQueue.find(o => o.query === focusedSearchHistoryQuery);
                const focusedIndex = focusableQueue.indexOf(focusedSearchHistoryItem as SearchHistoryItem);
                const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
                return { focusedSearchHistoryQuery: newFocusedOption?.query };
            });
        }
    }, 100);

    handlePopoverKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case DOWN_KEY:
                this.moveFocus("next");
                break;
            case UP_KEY:
                this.moveFocus("prev");
                break;
            case ENTER_KEY:
                /* Store Custom Code - Start */
                if (
                    this.props.searchable.turnOffEnterSearch &&
                    !this.state.focusedAutocompleteItem &&
                    !this.state.focusedSearchHistoryQuery
                ) {
                    return;
                }

                if (this.state.focusedAutocompleteItem) {
                    this.goToUrl(this.state.focusedAutocompleteItem.url);
                } else if (this.state.focusedSearchHistoryQuery) {
                    this.handleSearchHistoryChoice(this.state.focusedSearchHistoryQuery);
                } else {
                    this.doSearch();
                }
                /* Store Custom Code - End */
                break;
            default:
                break;
        }
    };

    handlePopoverClose = () => {
        if (!this.state.clickedProduct && (this.state.autoCompleteModel?.products?.length ?? 0) > 0) {
            this.props.sendAutocompleteOdpEvent({});
        }

        this.setState({
            clickedProduct: false,
        });

        /* Store Custom Code - Start */
        if (this.state.focusedAutocompleteItem || this.state.focusedSearchHistoryQuery || this.state.searchIsFocused) {
            this.setState({
                focusedAutocompleteItem: undefined,
                focusedSearchHistoryQuery: undefined,
                searchIsFocused: false,
            });
        }
        /* Store Custom Code - End */
    };

    trackAutcompleteSearchResults = () => {
        // Make sure only to trigger for autocomplete results
        if (!this.state.query || !this.props.autocompleteEnabled || !this.state.autoCompleteModel) {
            return;
        }

        const { categories, brands, content, products } = this.state.autoCompleteModel;
        const resultCount =
            (products?.length ?? 0) + (categories?.length || 0) + (content?.length || 0) + (brands?.length || 0);
        if (resultCount > 0) {
            // Track an autocomplete of 1+ items
            this.props.sendSearchTracking({
                searchEvent: "autocompleteSearchResults",
                searchTerm: this.state.query,
                resultCount,
                productCount: products?.length,
                categoryCount: categories?.length,
                contentCount: content?.length,
                brandCount: brands?.length,
            });
            return;
        }

        // Track zero resultCount search results and triggers from this.doSearch
        this.props.sendSearchTracking({
            searchEvent: "searchResults",
            searchTerm: this.state.query,
            resultCount,
        });
    };

    trackAutocompleteSelection = (url: string) => {
        const suggestionIndex = this.state.autoCompleteModel?.suggestions?.findIndex(o => o.url === url) ?? -1;
        const productIndex = this.state.autoCompleteModel?.products?.findIndex(o => o.url === url) ?? -1;
        const data = {
            searchQuery: this.state.query,
            searchPosition: suggestionIndex >= 0 ? suggestionIndex : productIndex,
            attributionToken: this.state.autoCompleteModel?.attributionToken,
        };

        if (data.searchPosition >= 0) {
            this.props.sendAutocompleteOdpEvent(data);
            this.setState({ clickedProduct: true });
        }
    };

    goToUrl = (url: string, track = true) => {
        this.trackAutocompleteSelection(url);

        this.props.onBeforeGoToUrl && this.props.onBeforeGoToUrl();
        if (track) {
            this.trackAutcompleteSearchResults();
        }
        this.closeAutocomplete();
        this.mobileSearchModalCloseHandler(); // Starter Custom Code
        this.setState({
            // don't use stale results on next search and go to wrong PDP
            autoCompleteModel: undefined,
            searchIsFocused: false, // Store Custom Code
        });
        /* Store Custom Code - Start */
        this.props.history.push(url);
        if (this.props.inputRef && "current" in this.props.inputRef) {
            this.props.inputRef.current?.blur();
        }
        /* Store Custom Code - End */
    };

    /* Store Custom Code */
    mobileSearchInput = this.props.inputRef;

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true });
        // bunzl deleted code, no need to focus on the input as it will have auto focus on mobile.
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };
    /* Store Custom Code - Start */
    handleAutoCompleteSearch = () => {
        this.setState({ searchIsFocused: false });
        this.handlePopoverClose();
        this.doSearch();
    };

    handleFocus = (event?: React.FocusEvent<HTMLElement>) => {
        if (event?.target && this.searchButton.current?.contains(event.target as Node)) {
            return;
        }
        this.setState({ searchIsFocused: true });
        if (!this.showAutocomplete) {
            this.showAutocomplete = true;
        }
        if (!this.state.autoCompleteModel && this.state.query) {
            this.loadAutocomplete(this.state.query);
            return;
        }
        this.openAutocomplete();
    };
    handleBlur = (event?: React.FocusEvent<HTMLElement>) => {
        if (this.props.isAddToListModalOpen || typeof window === "undefined" || typeof document === "undefined") {
            return;
        }

        const currentTarget = event?.currentTarget;
        window.setTimeout(() => {
            const activeElement = document.activeElement;
            if (currentTarget && activeElement && currentTarget.contains(activeElement)) {
                return;
            }

            this.closeAutocomplete();
            this.setState({
                focusedAutocompleteItem: undefined,
                focusedSearchHistoryQuery: undefined,
                searchIsFocused: false,
            });
        }, 0);
    };
    handleSearchHistoryChoice = (query: string) => {
        this.showAutocomplete = true;
        this.setState({ query, autoCompleteModel: undefined, searchIsFocused: true }, () => {
            this.loadAutocomplete(query);
            this.focusInput();
            this.openAutocomplete();
        });
    };

    /* Store Custom Code - End */
    renderAutocomplete = () => {
        if (!this.props.autocompleteEnabled) {
            return null;
        }

        if (!this.state.autoCompleteModel) {
            return null;
        }

        const {
            categories,
            brands,
            content,
            products,
            suggestions,
            popularBrands,
            popularCategories,
            isRetailSearchCompletionResults,
        } = this.state.autoCompleteModel;

        /* Store Custom Code - Start */
        // Retail Search (relevancy on) returns brand/category suggestions in the top-level
        // attributeResults tier -> popularCategories/popularBrands; Elasticsearch returns them in
        // categories/brands. Render whichever is populated.
        const displayCategories = categories && categories.length > 0 ? categories : popularCategories;
        const displayBrands = brands && brands.length > 0 ? brands : popularBrands;
        /* Store Custom Code - End */

        const isSearchable = this.props.searchable; // Starter Custom Code
        if (!isSearchable.useLegacyAutocomplete && isAutocompleteResultEmpty(this.state.autoCompleteModel)) {
            return (
                <StyledWrapper {...this.styles.autocompleteWrapper} data-test-selector="autoComplete_noneFound">
                    <StyledWrapper
                        css={css`
                            width: 100%;
                            padding: ${pxToRem(5, 0)};
                            color: ${getColor("text.main")};
                        `}
                    >
                        {siteMessage("Autocomplete_NoResults")}
                    </StyledWrapper>
                </StyledWrapper>
            );
        }
        /* Store Custom Code - Start */
        const hasProducts = !!(products && products.length > 0);
        const hasSuggestions = !!(suggestions && suggestions.length > 0);

        // Balanced column for the no-product views.
        const flexColumn = {
            css: css`
                display: flex;
                flex-direction: column;
                flex: 1;
                min-width: 0;
                gap: ${pxToRem(4)};
                padding: 0 ${pxToRem(16)};
            `,
        };

        const renderSuggestions = (hideHeader: boolean) =>
            hasSuggestions ? (
                <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                    <AutocompleteSuggestions
                        suggestions={suggestions}
                        focusedItem={this.state.focusedAutocompleteItem}
                        goToUrl={isSearchable.useLegacyAutocomplete ? this.goToUrl : this.handleSuggestionSearch}
                        onPopulate={this.handleSuggestionPopulate}
                        hideHeader={hideHeader}
                        extendedStyles={this.styles.autocompleteSuggestionsStyles}
                    />
                </StyledWrapper>
            ) : null;

        const categoriesBrandsContent = (
            <>
                {isSearchable.categories && displayCategories && displayCategories.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <AutocompleteCategories
                            categories={displayCategories}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteCategoriesStyles}
                        />
                    </StyledWrapper>
                )}
                {isSearchable.brands && displayBrands && displayBrands.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <AutocompleteBrands
                            brands={displayBrands}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteBrandsStyles}
                        />
                    </StyledWrapper>
                )}
                {isSearchable.contents && content && content.length > 0 && (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <AutocompleteContent
                            content={content}
                            focusedItem={this.state.focusedAutocompleteItem}
                            goToUrl={this.goToUrl}
                            extendedStyles={this.styles.autocompleteContentStyles}
                        />
                    </StyledWrapper>
                )}
            </>
        );

        const productsColumn = (
            <StyledWrapper {...this.styles.leftColumnWrapper}>
                {this.state.productsLoading && !hasProducts ? (
                    <>
                        <StyledWrapper
                            data-test-selector="auto-complete-products-skeleton-header"
                            css={css`
                                display: block;
                                margin: 0 0 ${pxToRem(5)} 0;
                                padding-bottom: ${pxToRem(5)};
                                text-align: left;
                                font-weight: ${x => x.theme.design.typography.weight.bold};
                                border-bottom: 1px solid ${getColor("common.border")};
                            `}
                        >
                            {translate("Products")}
                        </StyledWrapper>
                        <StyledWrapper
                            data-test-selector="auto-complete-products-skeleton"
                            css={css`
                                display: grid;
                                grid-template-columns: repeat(auto-fill, minmax(calc(50% - 1rem), 1fr));
                                @media (min-width: ${pxToRem(1500)}) {
                                    grid-template-columns: repeat(auto-fill, minmax(calc(33% - 1rem), 1fr));
                                }
                                width: 100%;
                                gap: ${pxToRem(16)};
                            `}
                        >
                            {[0, 1, 2, 3, 4, 5].map(i => (
                                <BunzlAutoCompleteProductWrapper
                                    key={`product-skeleton-${i}`}
                                    variant={this.props.searchable.cardStyle}
                                >
                                    <StyledWrapper
                                        css={css`
                                            display: flex;
                                            flex-direction: column;
                                            gap: ${pxToRem(10)};
                                            width: 100%;
                                        `}
                                    >
                                        <StyledWrapper
                                            css={css`
                                                ${lazyLoadKeyframes()}
                                                width: 100%;
                                                height: ${pxToRem(150)};
                                                border-radius: ${pxToRem(4)};
                                                ${lazyLoadStyles()}
                                            `}
                                        />
                                        <StyledWrapper
                                            css={css`
                                                ${lazyLoadKeyframes()}
                                                width: 85%;
                                                height: ${pxToRem(14)};
                                                border-radius: ${pxToRem(4)};
                                                ${lazyLoadStyles()}
                                            `}
                                        />
                                        <StyledWrapper
                                            css={css`
                                                ${lazyLoadKeyframes()}
                                                width: 60%;
                                                height: ${pxToRem(14)};
                                                border-radius: ${pxToRem(4)};
                                                ${lazyLoadStyles()}
                                            `}
                                        />
                                        <StyledWrapper
                                            css={css`
                                                ${lazyLoadKeyframes()}
                                                width: 100%;
                                                height: ${pxToRem(36)};
                                                border-radius: ${pxToRem(4)};
                                                ${lazyLoadStyles()}
                                            `}
                                        />
                                    </StyledWrapper>
                                </BunzlAutoCompleteProductWrapper>
                            ))}
                        </StyledWrapper>
                    </>
                ) : (
                    <StyledWrapper {...this.styles.autocompleteColumnWrapper}>
                        <Hidden below="md">
                            <BunzlAutoCompleteProducts
                                products={products ?? []}
                                handleAutoCompleteSearch={this.handleAutoCompleteSearch}
                                doSearch={this.doSearch}
                                variant={this.props.searchable.cardStyle}
                                goToUrl={this.goToUrl}
                                onProductAction={this.trackAutocompleteSelection}
                                isAuthenticated={this.props.isAuthenticated}
                                focusedItem={this.state.focusedAutocompleteItem}
                            />
                        </Hidden>
                        <Hidden above="sm">
                            <AutocompleteProducts
                                products={products ?? []}
                                focusedItem={this.state.focusedAutocompleteItem}
                                goToUrl={this.goToUrl}
                                extendedStyles={this.styles.autocompleteProductsStyles}
                            />
                        </Hidden>
                    </StyledWrapper>
                )}
            </StyledWrapper>
        );

        const divider = (
            <StyledWrapper
                css={css`
                    width: 1px;
                    border-left: 1px solid ${getColor("common.border")};
                `}
            />
        );
        /* Store Custom Code - End */
        return (
            // Starter Removed Code - Condition
            // Store Custom Code - >
            <StyledWrapper {...this.styles.autocompleteWrapper} data-test-selector="auto-complete-wrapper">
                {/* Store Custom Code - Start */}
                {hasProducts || this.state.productsLoading ? (
                    // Products (or loading skeletons) | (Categories + Brands + Search — all with headers)
                    <>
                        {productsColumn}
                        {divider}
                        <StyledWrapper {...this.styles.rightColumnWrapper}>
                            {categoriesBrandsContent}
                            {renderSuggestions(false)}
                        </StyledWrapper>
                    </>
                ) : hasSuggestions ? (
                    // [Suggestions (no header)] | [Categories + Brands (headers)]
                    <>
                        <StyledWrapper {...flexColumn}>{renderSuggestions(true)}</StyledWrapper>
                        {divider}
                        <StyledWrapper {...flexColumn}>{categoriesBrandsContent}</StyledWrapper>
                    </>
                ) : (
                    // Single column: Categories + Brands (headers)
                    <StyledWrapper {...flexColumn}>{categoriesBrandsContent}</StyledWrapper>
                )}
                {/* Store Custom Code - End */}
                {/* Starter Custom Code */}
            </StyledWrapper>
        );
        // <-- Bunzl Custom Code
    };

    render() {
        const styles = this.styles;

        const searchId = `headerSearch-${this.props.id}`;
        // Store Custom Code - >
        const loggedInSearchWidth = this.props.searchWidth - this.props.loggedInExtraWidth;
        const widthToUse = this.props.isAuthenticated ? loggedInSearchWidth : this.props.searchWidth;
        const isPopoverOpen = ((this.popover?.current as any)?.state?.open as boolean) || this.state.searchIsFocused;
        const overFlowWrapperProps = getOverFlowWrapperProps(
            this.state.searchIsFocused,
            widthToUse,
            this.props.isAuthenticated,
            this.handleBlur,
            this.handleFocus,
            this.props.searchable.useTabbedHeader,
            styles.popoverWrapper?.css,
        );
        // <-- Store Custom Code
        const searchInputProps = {
            ...styles.input,
            ref: this.props.inputRef,
            iconClickableProps: { onClick: this.doSearch, ref: this.searchButton },
            value: this.state.query,
            onChange: this.handleInputChange,

            placeholder: translate("Search"),
            // A11Y type for Accessibilty
            /* Store Custom Code - Start */
            type: isPopoverOpen ? "search" : "text",
            role: "combobox" as const,
            "aria-autocomplete": "list" as const,
            "aria-haspopup": "listbox" as const,
            /* Store Custom Code - End */
            autoComplete: "off",
            className: "search-input",
            clickableText: translate("submit search"),
            id: searchId,
            "data-test-selector": "headerSearchInputTextField",
        };
        /* Store Custom Code - Ios will not allow you to bring up the keyboard on focus if the input is not rendered when the click event fires, autofocus gets around that.
        The other option is to have an invisible input that is focused on click of the search icon */
        const searchInput = <TextField {...searchInputProps} onClickCapture={event => event.stopPropagation()} />;
        const mobileSearchInput = <TextField {...searchInputProps} autoFocus />;

        // <-- Bunzl Custom Code
        return (
            <>
                <VisuallyHidden as="label" htmlFor={searchId} id={`${searchId}-label`}>
                    {translate("Site Search")}
                </VisuallyHidden>
                {/* Starter Custom Code - Hidden */}
                <Hidden below="sm">
                    <Popover
                        {...styles.popover}
                        controlsId={`${searchId}-popover`}
                        ref={this.popover}
                        insideRefs={[this.list, this.addToListModal]}
                        popoverTrigger={searchInput}
                        positionFunction={this.getPopoverPosition}
                        // Store Custom Code
                        wrapperProps={overFlowWrapperProps}
                        contentBodyProps={
                            {
                                ref: this.list,
                                ...styles.popoverContentBody,
                            } as any
                        }
                        handleKeyDown={this.handlePopoverKeyDown}
                        onClose={this.handlePopoverClose}
                    >
                        {!this.state.query && this.showAutocomplete && (
                            <SearchHistory
                                focusedQuery={this.state.focusedSearchHistoryQuery}
                                goToUrl={this.goToUrl}
                                onClickOverride={this.handleSearchHistoryChoice}
                                extendedStyles={styles.searchHistoryStyles}
                            />
                        )}
                        {this.state.query && this.renderAutocomplete()}
                    </Popover>
                </Hidden>
                {/* Starter Custom Code - Hidden */}
                {/* Starter Custom Code */}
                <Hidden above="xs" {...styles.mobileSearchIconWrapper}>
                    {/* Store Custom Code - Start */}

                    <ButtonIcon
                        {...styles.mobileSearchIcon}
                        src={Search}
                        onClick={this.mobileSearchButtonClickHandler}
                    />
                    {!this.props.isAuthenticated && (
                        <Clickable href={this.props.signInUrl}>
                            <Icon src={StoreUser} color="primary" size={28} />
                        </Clickable>
                    )}
                    {/* Store Custom Code - End */}
                </Hidden>
                <Modal
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    /* Store Custom Code */
                    headline={mobileSearchInput}
                >
                    {!this.state.query && this.showAutocomplete && (
                        <SearchHistory
                            focusedQuery={this.state.focusedSearchHistoryQuery}
                            goToUrl={this.goToUrl}
                            extendedStyles={styles.searchHistoryStyles}
                        />
                    )}
                    {this.state.query && this.renderAutocomplete()}
                </Modal>
                {/* Starter Custom Code */}
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(withTheme(SearchInput)));
